/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ReasonForKeepPI {
    AUTO = 'Auto',
    PREMISES_LIABILITY = 'PremisesLiability',
    MED_MAL = 'MedMal',
}
